<template>
    <Menu />

    <div class="px-5 py-6">
        <Back state="back" />

        <figure v-if="showExtras">
            <ApplicationSlogan />
        </figure>
    </div>

</template>

<script>
import ApplicationSlogan from "@/Components/ApplicationSlogan.vue";
import Back from "@/Components/UI/Back.vue";
import Menu from "@/Components/UI/Nav/Menu.vue";

export default {
    components: {
        ApplicationSlogan,
        Back,
        Menu,
    },

    props: {
        showExtras: {
            default: true,
            type: Boolean
        },
        nomeDaCampanha: String,
        nomeDaPagina: String
    },
};
</script>
